import type { Vehicle, VehicleType } from "@/types";
import {
  VEHICLE_MODEL_MAP,
  defaultModelForCategory,
  type VehicleModelDef,
  type VehicleModelKey,
} from "./models";

export function resolveVehicleModel(
  iconKey: string | undefined,
  category: VehicleType | undefined,
): VehicleModelDef {
  if (iconKey && iconKey in VEHICLE_MODEL_MAP) {
    return VEHICLE_MODEL_MAP[iconKey as VehicleModelKey];
  }
  return VEHICLE_MODEL_MAP[defaultModelForCategory(category)];
}

export function resolveVehicleModelFor(v: Vehicle): VehicleModelDef {
  return resolveVehicleModel(v.iconKey, v.type);
}
